import Text from 'components/Text'
import React from 'react'

export default function SetRowNotes ({
  notes,
  isRest
}) {
  if (isRest || !notes) {
    return null
  }

  return (
    <Text
      fs='11px'
      mt={0.25}
    >
      {notes}
    </Text>
  )
}
